module.exports = {
  title: 'Swipe Cards with React Native Reanimated',
  author: 'Enzo Manuel Mangano',
  date: '2024-06-12',
  slug: 'imessage-stack',
  tags: ['reanimated'],
};
